import { render, staticRenderFns } from "./VirtualGuardLogo.vue?vue&type=template&id=4307d333&"
import script from "./VirtualGuardLogo.vue?vue&type=script&lang=js&"
export * from "./VirtualGuardLogo.vue?vue&type=script&lang=js&"
import style0 from "./VirtualGuardLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports